var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 341,
    height: 170,
    viewBox: "0 0 341 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.39062 -9.34334V9.34434L9.07463 12.0283V-12.0273L6.39062 -9.34334Z",
    fill: "url(#paint0_linear_740_11537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5156 -26.4703V26.4699L26.1996 29.1539V-29.1543L23.5156 -26.4703Z",
    fill: "url(#paint1_linear_740_11537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6406 -43.5963V43.5972L43.3246 46.2812V-46.2803L40.6406 -43.5963Z",
    fill: "url(#paint2_linear_740_11537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7695 -60.7232V60.7231L60.4535 63.4071V-63.4072L57.7695 -60.7232Z",
    fill: "url(#paint3_linear_740_11537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8945 -77.8492V77.8503L77.5785 80.5343V-80.5332L74.8945 -77.8492Z",
    fill: "url(#paint4_linear_740_11537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0234 -94.9762V94.9756L94.7074 97.6596V-97.6602L92.0234 -94.9762Z",
    fill: "url(#paint5_linear_740_11537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.148 -112.102V112.103L111.832 114.787V-114.786L109.148 -112.102Z",
    fill: "url(#paint6_linear_740_11537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.277 -129.229V129.229L128.961 131.913V-131.913L126.277 -129.229Z",
    fill: "url(#paint7_linear_740_11537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.402 -146.355V146.356L146.086 149.04V-149.039L143.402 -146.355Z",
    fill: "url(#paint8_linear_740_11537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.527 -163.482V163.482L163.211 166.166V-166.166L160.527 -163.482Z",
    fill: "url(#paint9_linear_740_11537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.656 -166.188V166.187L180.34 163.503V-163.503L177.656 -166.188Z",
    fill: "url(#paint10_linear_740_11537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.781 -149.061V149.061L197.465 146.377V-146.377L194.781 -149.061Z",
    fill: "url(#paint11_linear_740_11537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.91 -131.935V131.934L214.594 129.25V-129.251L211.91 -131.935Z",
    fill: "url(#paint12_linear_740_11537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.035 -114.808V114.808L231.719 112.124V-112.124L229.035 -114.808Z",
    fill: "url(#paint13_linear_740_11537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.16 -97.6807V97.6823L248.844 94.9983V-94.9967L246.16 -97.6807Z",
    fill: "url(#paint14_linear_740_11537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.289 -80.5547V80.5551L265.973 77.8711V-77.8707L263.289 -80.5547Z",
    fill: "url(#paint15_linear_740_11537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.414 -63.4277V63.4288L283.098 60.7448V-60.7437L280.414 -63.4277Z",
    fill: "url(#paint16_linear_740_11537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.539 -46.3018V46.3016L300.223 43.6176V-43.6178L297.539 -46.3018Z",
    fill: "url(#paint17_linear_740_11537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.668 -29.1758V29.1754L317.352 26.4914V-26.4918L314.668 -29.1758Z",
    fill: "url(#paint18_linear_740_11537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.793 -12.0488V12.0491L334.477 9.36513V-9.36483L331.793 -12.0488Z",
    fill: "url(#paint19_linear_740_11537)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_11537",
    x1: 7.01162,
    y1: 1.5735,
    x2: 9.05534,
    y2: 1.57345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_740_11537",
    x1: 24.1366,
    y1: 3.81259,
    x2: 26.1803,
    y2: 3.81257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_740_11537",
    x1: 41.2616,
    y1: 6.05303,
    x2: 43.3053,
    y2: 6.05302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_740_11537",
    x1: 58.3905,
    y1: 8.29232,
    x2: 60.4342,
    y2: 8.29231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_740_11537",
    x1: 75.5155,
    y1: 10.5328,
    x2: 77.5592,
    y2: 10.5328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_740_11537",
    x1: 92.6444,
    y1: 12.7717,
    x2: 94.6881,
    y2: 12.7717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_740_11537",
    x1: 109.769,
    y1: 15.0121,
    x2: 111.813,
    y2: 15.0121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_740_11537",
    x1: 126.898,
    y1: 17.2516,
    x2: 128.942,
    y2: 17.2516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_740_11537",
    x1: 144.023,
    y1: 19.492,
    x2: 146.067,
    y2: 19.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_740_11537",
    x1: 161.148,
    y1: 21.7309,
    x2: 163.192,
    y2: 21.7309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_740_11537",
    x1: 178.277,
    y1: 21.7339,
    x2: 180.321,
    y2: 21.7339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_740_11537",
    x1: 195.402,
    y1: 19.4944,
    x2: 197.446,
    y2: 19.4944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_740_11537",
    x1: 212.531,
    y1: 17.254,
    x2: 214.575,
    y2: 17.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_740_11537",
    x1: 229.656,
    y1: 15.0145,
    x2: 231.7,
    y2: 15.0145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_740_11537",
    x1: 246.781,
    y1: 12.7756,
    x2: 248.825,
    y2: 12.7756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_740_11537",
    x1: 263.91,
    y1: 10.5352,
    x2: 265.954,
    y2: 10.5352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_740_11537",
    x1: 281.035,
    y1: 8.29571,
    x2: 283.079,
    y2: 8.2957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_740_11537",
    x1: 298.16,
    y1: 6.05526,
    x2: 300.204,
    y2: 6.05525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_740_11537",
    x1: 315.289,
    y1: 3.81539,
    x2: 317.333,
    y2: 3.81537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_740_11537",
    x1: 332.414,
    y1: 1.57592,
    x2: 334.458,
    y2: 1.57586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.83731a1704a31fbcef3164e10b1b1a27.svg";
export { ForwardRef as ReactComponent };